module.exports = __webpack_public_path__ + "fonts/visuelt-pro-regular.e9feb6c8.ttf";